var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.84 7.34667V10.66C2.84 11.8733 2.84 11.8733 3.98667 12.6467L7.14 14.4667C7.61333 14.74 8.38667 14.74 8.86 14.4667L12.0133 12.6467C13.16 11.8733 13.16 11.8733 13.16 10.66V7.34667C13.16 6.13333 13.16 6.13333 12.0133 5.36L8.86 3.54C8.38667 3.26667 7.61333 3.26667 7.14 3.54L3.98667 5.36C2.84 6.13333 2.84 6.13333 2.84 7.34667Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6667 5.08667V3.33333C11.6667 2 11 1.33333 9.66667 1.33333H6.33333C5 1.33333 4.33333 2 4.33333 3.33333V5.04",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.42 7.32667L8.8 7.92C8.86 8.01333 8.99333 8.10667 9.09333 8.13333L9.77333 8.30667C10.1933 8.41333 10.3067 8.77333 10.0333 9.10667L9.58667 9.64667C9.52 9.73333 9.46667 9.88667 9.47333 9.99333L9.51333 10.6933C9.54 11.1267 9.23333 11.3467 8.83333 11.1867L8.18 10.9267C8.08 10.8867 7.91333 10.8867 7.81333 10.9267L7.16 11.1867C6.76 11.3467 6.45333 11.12 6.48 10.6933L6.52 9.99333C6.52667 9.88667 6.47333 9.72667 6.40667 9.64667L5.96 9.10667C5.68667 8.77333 5.8 8.41333 6.22 8.30667L6.9 8.13333C7.00667 8.10667 7.14 8.00667 7.19333 7.92L7.57333 7.32667C7.81333 6.96667 8.18667 6.96667 8.42 7.32667Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0,
    d: "M0.650391 15.3496L0.650391 0.650391L15.3496 0.650391L15.3496 15.3496L0.650391 15.3496Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardBlue);
export default __webpack_public_path__ + "static/media/award-blue.721e678e725670b3cf1dba8c57fd6b0b.svg";
export { ForwardRef as ReactComponent };